import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePaycodesActions } from 'hooks/paycodes/usePaycodesActions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

interface Props {
    open: boolean;
    setOpen: (open: boolean) => void;
    selectedRow: any[];
    reloading: () => void;
}

export const PaycodeDelete = ({ open, setOpen, selectedRow, reloading }: Props) => {
    const { t } = useTranslation();
    const { deletePaycodes } = usePaycodesActions();

    const [loadingDeletingPaycode, setLoadingDeletingPaycode] = useState(false);

    return (
        <>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>{t('settings.paycodes.table.modals.delete.title')}</DialogTitle>

                <DialogContent>
                    <Typography variant="body1">{t('settings.paycodes.table.modals.delete.message')}</Typography>
                </DialogContent>

                <DialogActions sx={{ pb: 2, pr: 3 }}>
                    <Button
                        variant="contained"
                        disableElevation
                        onClick={() => {
                            deletePaycodes({
                                setLoading: setLoadingDeletingPaycode,
                                paycodeIds: selectedRow.map((paycode) => paycode.id),
                                closing: () => setOpen(false),
                                reloading,
                                messageError: {
                                    title: t('settings.paycodes.table.alerts.error_delete_paycode.title'),
                                    message: t('settings.paycodes.table.alerts.error_delete_paycode.message'),
                                    severity: 'error',
                                },
                                messageSuccess: {
                                    title: t('settings.paycodes.table.alerts.delete_paycode.title'),
                                    message: t('settings.paycodes.table.alerts.delete_paycode.message'),
                                    severity: 'success',
                                },
                                handlerAlert: (message) => {
                                    enqueueSnackbar(message.message, { variant: message.severity });
                                },
                            });
                        }}
                        color="error"
                        disabled={loadingDeletingPaycode}
                    >
                        {t('settings.paycodes.table.modals.delete.buttons.delete')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
